import { isAfter } from "date-fns";

import { useEpisodes } from "@/contexts/EpisodesContext";
import useSearchParams from "@/hooks/useSearchParams";
import { indexUsing } from "@/utils";
import { hasValidFilters } from "@components/SearchFilter/utils";

// Find out whether we have an item in the array that is after the last_read_at timestamp

const useShowUnreadNotice = () => {
  const [filter] = useSearchParams();
  const isFilteredView = hasValidFilters(filter);
  const [{ sort_by = undefined }] = useSearchParams();
  const { episodes, alert } = useEpisodes();

  const lastReadAt = alert?.last_read_at ? new Date(alert.last_read_at) : null;

  const index = lastReadAt
    ? indexUsing(episodes, (mention) => {
        const mentionDate = new Date(mention?.post_data?.published_date);
        return isAfter(lastReadAt, mentionDate);
      })
    : -1;

  // Don't give a positive index if:
  return !isFilteredView && // - The user has not filtered for anything
    index !== 0 && // - This is not the first episode we're seeing on the first page.
    (sort_by === "date" || sort_by === undefined) // ... And we've sorted by anything else than date ( which is default, hence || undefined)
    ? index
    : -1; // -1 never hits any index in the render map so return that
};

export default useShowUnreadNotice;
